import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';
import { objectToURLParams } from 'helpers/utils';

export interface UsageReportsRecommendationReportGetOptions {
  startDate: string;
  endDate: string;
  adviserId?: number;
}

export function usageReportsRecommendationReportApi(path: string) {
  const generatePath = (params?: UsageReportsRecommendationReportGetOptions) =>
    params ? `${path}?${objectToURLParams(mapFormData(params))}` : path;

  return {
    path,
    GET: (params?: UsageReportsRecommendationReportGetOptions) => api.get(generatePath(params)),
    GETPath: (params?: UsageReportsRecommendationReportGetOptions) => generatePath(params),
  };
}
